var _desc, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMobilePhone = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 1.7.22")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 128) scale(0.72 0.72)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(-175.05 -175.05000000000004) scale(3.89 3.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 55.229 78.816 v 6.086 c 0 0.606 -0.493 1.098 -1.098 1.098 H 18.004 c -0.606 0 -1.098 -0.493 -1.098 -1.098 V 4.731 C 16.906 4.328 17.234 4 17.637 4 h 5.689 c 0.379 2.345 2.052 4.126 4.044 4.126 h 17.396 c 1.992 0 3.664 -1.781 4.044 -4.126 h 5.321 c 0.606 0 1.098 0.493 1.098 1.098 v 18.809 c 1.362 0.081 2.698 0.258 4 0.531 V 5.098 C 59.229 2.283 56.946 0 54.131 0 H 17.637 c -2.613 0 -4.731 2.118 -4.731 4.731 v 80.171 c 0 2.816 2.283 5.098 5.098 5.098 h 36.126 c 2.816 0 5.098 -2.283 5.098 -5.098 v -6.617 C 57.927 78.557 56.591 78.735 55.229 78.816 z M 41.948 4.25 c 0.414 0 0.75 0.336 0.75 0.75 c 0 0.414 -0.336 0.75 -0.75 0.75 c -0.414 0 -0.75 -0.336 -0.75 -0.75 C 41.198 4.586 41.534 4.25 41.948 4.25 z M 29.437 4.25 h 9.466 c 0.414 0 0.75 0.336 0.75 0.75 s -0.336 0.75 -0.75 0.75 h -9.466 c -0.414 0 -0.75 -0.336 -0.75 -0.75 S 29.023 4.25 29.437 4.25 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 53.586 27.853 c -12.983 0 -23.508 10.525 -23.508 23.508 c 0 12.983 10.525 23.508 23.508 23.508 s 23.508 -10.525 23.508 -23.508 C 77.094 38.378 66.569 27.853 53.586 27.853 z M 63.086 53.91 h -7 v 7 c 0 1.381 -1.119 2.5 -2.5 2.5 s -2.5 -1.119 -2.5 -2.5 v -7 h -7 c -1.381 0 -2.5 -1.119 -2.5 -2.5 s 1.119 -2.5 2.5 -2.5 h 7 v -7 c 0 -1.381 1.119 -2.5 2.5 -2.5 s 2.5 1.119 2.5 2.5 v 7 h 7 c 1.381 0 2.5 1.119 2.5 2.5 S 64.467 53.91 63.086 53.91 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMobilePhone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mobile-phone.svg";